import { render, staticRenderFns } from "./RequestFilters.vue?vue&type=template&id=1bc8e0d7&"
import script from "./RequestFilters.vue?vue&type=script&lang=js&"
export * from "./RequestFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports